export const NOTIFY = 'NOTIFY';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';